/* lp-dishgrill.js — /pages/dish-grill-lp（daily） & /pages/dish-grill-lp-outdoor（outdoor）専用
   目的：
     - LINE登録ボタン（クーポン等）→ Lead（cta:'line_add'）
     - お問い合わせボタン（LINE遷移）→ Contact も送るが、最適化のため Lead（cta:'line_add'）も送る
   ポイント：
     - LP本文は無改変。テーマ側からこのJSだけ読み込む
     - お問い合わせ導線は bindLeadLinks では除外し、委譲ハンドラで Lead を送る（重複発火防止）
sevond だけおくる　問い合わせボタンは別途管理しない
*/

(function () {
  // === 対象URLだけで動作（/pages/... の末尾スラッシュ差異を吸収） ===
  var rawPath = location.pathname;
  var path = rawPath.replace(/\/+$/, ''); // 末尾スラッシュ除去
  var scenarioMap = {
    '/pages/dish-grill-lp': 'daily',
    '/pages/dish-grill-lp-outdoor': 'outdoor',
    '/pages/dish-grill-lp-second': 'second'
  };
  var PAGE_SCENARIO = scenarioMap[path] || null;
  if (!PAGE_SCENARIO) return; // 他ページでは一切動作しない

  // === お問い合わせリンク判定（目印がなくても拾える保険付き） ===
  function isInquiry(el){
    if (!el) return false;
    var txt  = (el.getAttribute('aria-label') || el.textContent || '').trim();
    var cta  = (el.dataset && el.dataset.cta) || '';
    return (
      cta === 'inquiry' ||                        // 明示data属性（推奨）
      el.classList.contains('js-inquiry') ||      // 明示クラス
      el.id === 'inquiryBtn' ||                   // 既存ID
      /お問い合わせ|問合せ|inquiry/i.test(txt)    // 文言判定（保険）
    );
  }

  // === fbqのロード待ち ===
  function waitFbq(fn, maxMs, step){
    maxMs = maxMs || 6000; step = step || 200;
    var waited = 0;
    (function tick(){
      if (typeof fbq === 'function') { fn(); return; }
      waited += step;
      if (waited < maxMs) setTimeout(tick, step);
    })();
  }

  // === Lead（LINE登録＝クーポン等）をバインド：※お問い合わせは除外して二重発火防止 ===
  function bindLeadLinks(){
    var anchors = Array.prototype.slice.call(document.querySelectorAll('a[href*="lin.ee"]'));
    anchors.forEach(function(a){
      if (isInquiry(a)) return;               // お問い合わせ導線はLeadから除外（委譲側で送る）
      if (a.dataset.fbqLeadBound === '1') return;
      a.dataset.fbqLeadBound = '1';
      a.addEventListener('click', function(){
        if (a.dataset.fbqLeadSent === '1') return;
        a.dataset.fbqLeadSent = '1';
        var scenario = a.dataset.scenario || PAGE_SCENARIO;
        try {
          fbq('trackCustom','Lead_Click',{ cta:'line_add', scenario: scenario });
          fbq('track','Lead',{ cta:'line_add', scenario: scenario });
        } catch (e) {}
      }, { once: true });
    });
  }

  // === Contact（お問い合わせ＝LINE遷移）：委譲で常に拾う + 最適化用にLeadも送る ===
  function enableInquiryDelegation(){
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href*="lin.ee"]');
      if (!a || !isInquiry(a)) return;        // お問い合わせ判定
      if (a.dataset.fbqInquirySent === '1') return;
      a.dataset.fbqInquirySent = '1';

      var scenario = a.dataset.scenario || PAGE_SCENARIO;
      var label = a.getAttribute('aria-label') || (a.textContent || '').trim().slice(0,80) || 'inquiry';

      try {
        // 分析用：問い合わせ系イベント
        fbq('track','Contact',{ cta:'inquiry', scenario: scenario, label: label });
        fbq('trackCustom','Inquiry_Click',{ cta:'inquiry', scenario: scenario, label: label, path: location.pathname });

        // 最適化用：LINE登録CVと同じイベント/CTAで送信（＝広告のCVにも含まれる）
        fbq('track','Lead',{ cta:'line_add', scenario: scenario });
        fbq('trackCustom','Lead_Click',{ cta:'line_add', scenario: scenario });
      } catch (e) {}
    }, true);
  }

  // === DOM変化でLeadバインドを継続（後からボタン追加されてもOK） ===
  function observeForNewLinks(){
    var obs = new MutationObserver(bindLeadLinks);
    obs.observe(document.documentElement, { childList:true, subtree:true });
  }

  function init(){
    bindLeadLinks();          // 既存lin.eeリンクにLead（お問い合わせは除外）
    enableInquiryDelegation();// 問い合わせは委譲で拾いつつ Lead も送る
    observeForNewLinks();     // 後から追加されてもOK
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ waitFbq(init); });
  } else {
    waitFbq(init);
  }
})();
